import React, { useMemo } from 'react';
import { PlaidBankCardItem } from 'components/vendor/plaid';
import classlist from 'utils/classlist';
import GeneralLogo from './images/bank-logo/General.png';
import ins_1 from './images/bank-logo/ins_1.png';
import ins_11 from './images/bank-logo/ins_11.png';
import ins_12 from './images/bank-logo/ins_12.png';
import ins_13 from './images/bank-logo/ins_13.png';
import ins_14 from './images/bank-logo/ins_14.png';
import ins_15 from './images/bank-logo/ins_15.png';
import ins_16 from './images/bank-logo/ins_16.png';
import ins_2 from './images/bank-logo/ins_2.png';
import ins_20 from './images/bank-logo/ins_20.png';
import ins_21 from './images/bank-logo/ins_21.png';
import ins_25 from './images/bank-logo/ins_25.png';
import ins_3 from './images/bank-logo/ins_3.png';
import ins_35 from './images/bank-logo/ins_35.png';
import ins_4 from './images/bank-logo/ins_4.png';
import ins_5 from './images/bank-logo/ins_5.png';
import ins_6 from './images/bank-logo/ins_6.png';
import ins_7 from './images/bank-logo/ins_7.png';
import ins_9 from './images/bank-logo/ins_9.png';
import './style.scss';

// 银行logo映射表
const bankLogoMap: Record<string, string> = {
    ins_1,
    ins_2,
    ins_3,
    ins_4,
    ins_5,
    ins_6,
    ins_7,
    ins_9,
    ins_11,
    ins_12,
    ins_13,
    ins_14,
    ins_15,
    ins_16,
    ins_20,
    ins_21,
    ins_25,
    ins_35
};

interface AchBankLogoProps extends PlaidBankCardItem {
    className?: string;
}

const AchBankLogo: React.FC<AchBankLogoProps> = ({ institution_id, instruction_name, className }) => {
    const logoSrc = useMemo(() => {
        return bankLogoMap[institution_id] || GeneralLogo;
    }, [institution_id]);

    return <img className={classlist('ach-bank-logo', className)} src={logoSrc} alt={instruction_name} />;
};

export default AchBankLogo;
